import queryTransformer from '@htmniseko/htm-helpers/api/queryTransformer';

const transformQuery = queryTransformer({});

export default function transform(params) {
  // Transform all the current API query parameters to HTM API query format
  const queries = transformQuery(params);
  return queries.join('&');
}
